
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useLocalizedPath } from '../utils/localizedPath.js';

const RedirectIfAuth = ({ children }) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const { localize } = useLocalizedPath();

  if (authStatus === 'authenticated') {
    return <Navigate to={localize('/dashboard')} replace />;
  }

  return children;
};

export default RedirectIfAuth;
